// extracted by mini-css-extract-plugin
export default {"schoolInfo":"SchoolInfo_schoolInfo__ZPQsu","schoolHeader":"SchoolInfo_schoolHeader__0xjBJ"};